import { render, staticRenderFns } from "./PasswordResetChange.vue?vue&type=template&id=23552132"
import script from "./PasswordResetChange.vue?vue&type=script&lang=js"
export * from "./PasswordResetChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports